import { render, staticRenderFns } from "./ConfigCompany.vue?vue&type=template&id=77fc97ff"
import script from "./ConfigCompany.vue?vue&type=script&lang=js"
export * from "./ConfigCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports